module.exports = __webpack_public_path__ + "static/media/arced_shots.081ad4d7.png";